import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ModalPortal from '../ModalPortal';
import iconSupport from './icon-support.svg';
import VERTICAL_TITLES from '../../constants/verticalTitles';
import './ModalEnrollmentRejection.css';

const propTypes = {
  verticalTitle: PropTypes.string,
};

const defaultProps = {
  verticalTitle: VERTICAL_TITLES.boa,
};

class ModalEnrollmentRejection extends PureComponent {
  hide() {
    window.$(this.modal).modal('hide');
  }

  show() {
    window.$(this.modal).modal('show');
  }

  get rejectiontext() {
    const { verticalTitle } = this.props;

    switch (verticalTitle) {
      case VERTICAL_TITLES.boa:
        return (
          <>
            <p>
              Based on one or more of your responses we will need some
              additional information from you to provide a quote.
            </p>
            <p>
              To request a customized proposal please email Chubb Underwriting
              directly at{' '}
              <a href="mailto:CAHDigitalSales@Chubb.com">
                CAHDigitalSales@Chubb.com
              </a>{' '}
              or call <a href="tel:8333249797">833-324-9797</a> for further
              information.
            </p>
          </>
        );

      case VERTICAL_TITLES.passport:
        return (
          <>
            <p>
              We seem to be having technical difficulties and are unable to
              provide a quote at this time.
            </p>
            <p>
              For further assistance, please contact your agent or Chubb
              directly at{' '}
              <a href="mailto:CAHDigitalSales@Chubb.com">
                CAHDigitalSales@Chubb.com
              </a>{' '}
              or <a href="tel:8333249797">833-324-9797</a>.
            </p>
          </>
        );
      default:
        return null;
    }
  }

  render() {
    const { verticalTitle } = this.props;
    return (
      <ModalPortal>
        <div
          className="ModalEnrollmentRejection modal"
          id="enrollClientModal"
          ref={(c) => (this.modal = c)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content-wrapper">
              <div className="modal-content">
                <div className="modal-body ModalEnrollmentRejection">
                  <img
                    className="ModalEnrollmentRejection-icon"
                    src={iconSupport}
                    alt="Support Icon"
                  />
                  <h3 className="ModalEnrollmentRejection-heading">
                    Thank you for your interest in {verticalTitle} Accident
                    Insurance from Chubb.
                  </h3>
                  {this.rejectiontext}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}

ModalEnrollmentRejection.propTypes = propTypes;
ModalEnrollmentRejection.defaultProps = defaultProps;

export default ModalEnrollmentRejection;
